import { LinearGradient } from 'expo-linear-gradient';
import { Platform, StyleSheet, Text, TouchableOpacity } from 'react-native';
import { fontFamilies } from '../utils/fontLoader';

// Gradient button
export const GradientButton = ({
  onPress,
  text,
  style,
  textStyle,
  children,
  disabled = false,
  accessibilityLabel,
  accessibilityHint,
  accessibilityRole = 'button',
  accessibilityState,
  // Allow customizing gradient colors
  gradientColors,
  // Allow customizing inner style
  innerStyle,
}) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      disabled={disabled}
      style={[styles.buttonOuterContainer, style]}
      accessible={true}
      accessibilityLabel={accessibilityLabel || `${text} button`}
      accessibilityRole={accessibilityRole}
      accessibilityHint={accessibilityHint}
      accessibilityState={accessibilityState || { disabled }}
    >
      <LinearGradient
        colors={disabled ? ['#D1D5DB', '#D1D5DB'] : gradientColors || ['#0E0E0E', '#0E0E0E']}
        start={{ x: 0.5, y: 0 }}
        end={{ x: 0.5, y: 1 }}
        style={[styles.gradientButtonInner, disabled && styles.disabledButton, innerStyle]}
      >
        {children || <Text style={[styles.buttonText, textStyle]}>{text}</Text>}
      </LinearGradient>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  buttonOuterContainer: {
    borderRadius: 32, // From Figma
    alignSelf: 'center',
    ...Platform.select({
      web: {
        boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.15)',
      },
      default: {
        boxShadow: {
          offsetX: 0,
          offsetY: 5,
          blurRadius: 10,
          spreadDistance: 0,
          color: 'rgba(0, 0, 0, 0.15)',
        },
        elevation: 5,
      },
    }),
  },
  gradientButtonInner: {
    paddingVertical: 12,
    paddingHorizontal: 48, // From Figma
    borderRadius: 32, // From Figma
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 120,
    minHeight: 48, // From Figma exactly
    flexDirection: 'row',
  },
  buttonText: {
    fontFamily: fontFamilies.satoshi.bold,
    fontWeight: '700',
    fontSize: 14, // From Figma
    lineHeight: 22.4, // 1.6em from Figma
    letterSpacing: -0.14, // -1% from Figma
    color: '#FFFFFF',
    textAlign: 'center',
  },
  disabledButton: {
    opacity: 0.7,
  },
});

export default {
  GradientButton,
};
